module.exports = __webpack_public_path__ + "static/media/logo.af24ba58.png";